(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    /* MIZUKI newsletter motion v4.0: recheck the live destination on long pages.
   Replace the v3 block; do not load both versions. No form submission changes. */
(() => {
  if (window.__mizukiNewsletterMotionV1) return;
  window.__mizukiNewsletterMotionV1 = true;

  const hash = '#mizuki-newsletter';
  const hintClass = 'mizuki-newsletter-arriving';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const maxTrackingMs = 8000;
  let run = null;
  let frame = 0;
  let hintTimer = 0;
  let activeTarget = null;
  let allowInitialVisit = true;

  function isVisible(element) {
    if (!element || !element.isConnected || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      style.visibility !== 'collapse' && rect.width > 0 && rect.height > 0;
  }

  // Avoid a hidden desktop copy being selected ahead of the mobile footer.
  function getTarget() {
    const targets = Array.from(document.querySelectorAll('[id="mizuki-newsletter"]'))
      .filter((element) => isVisible(element) && isVisible(element.querySelector('input[type="email"]')));
    return targets.find((element) => element.closest('footer, #footer-group, .footer-section')) ||
      targets[0] || null;
  }

  function usesDesktopPanel() {
    return desktop.matches && !!document.querySelector('.mizuki-newsletter-popover');
  }

  function clearHint() {
    window.clearTimeout(hintTimer);
    hintTimer = 0;
    if (activeTarget) activeTarget.classList.remove(hintClass);
    activeTarget = null;
  }

  function cancel(stopScroll = false) {
    const wasTracking = !!run;
    window.cancelAnimationFrame(frame);
    frame = 0;
    run = null;
    clearHint();
    if (stopScroll && wasTracking) {
      window.scrollTo({ top: window.scrollY, left: window.scrollX, behavior: 'instant' });
    }
  }

  // Measure the input rather than the whole row (the button can be on a new line).
  function positionArrivalLine(target) {
    const group = target.querySelector('.email-signup__input-group');
    const input = group && group.querySelector('.email-signup__input');
    if (!group || !input) return;
    group.style.setProperty('--mizuki-line-left', `${input.offsetLeft}px`);
    const lineTop = group.classList.contains('email-signup__input-group--underline')
      ? group.clientHeight
      : input.offsetTop + input.offsetHeight - 1.5;
    group.style.setProperty('--mizuki-line-top', `${lineTop}px`);
    group.style.setProperty('--mizuki-line-width', `${input.offsetWidth}px`);
  }

  function showHint(target, keyboard) {
    if (keyboard) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    if (reducedMotion.matches) return;
    positionArrivalLine(target);
    clearHint();
    activeTarget = target;
    target.classList.remove(hintClass);
    void target.offsetWidth;
    target.classList.add(hintClass);
    hintTimer = window.setTimeout(clearHint, 2100);
  }

  function geometry(target) {
    const visual = window.visualViewport;
    const viewportTop = visual ? visual.offsetTop : 0;
    const viewportHeight = visual ? visual.height : window.innerHeight;
    const viewportBottom = viewportTop + viewportHeight;
    let coveredTop = viewportTop;

    // Include only header rows actually covering the top of this viewport.
    const rows = Array.from(document.querySelectorAll(
      '#header-component, .header-section, #header-group > .shopify-section'
    )).filter(isVisible).map((element) => element.getBoundingClientRect())
      .sort((a, b) => a.top - b.top);
    for (const rect of rows) {
      if (rect.top <= coveredTop + 4 && rect.bottom > coveredTop &&
          rect.bottom < viewportTop + viewportHeight * 0.55) {
        coveredTop = rect.bottom;
      }
    }

    const safeTop = coveredTop + 24;
    const safeBottom = viewportBottom - 24;
    const available = Math.max(80, safeBottom - safeTop);
    const rect = target.getBoundingClientRect();
    const input = target.querySelector('input[type="email"]');
    const inputRect = input ? input.getBoundingClientRect() : rect;
    // Usually center the heading and form together. For an unusually tall block,
    // center the actual email field instead of empty space inside its container.
    const anchor = rect.height <= available ? rect : inputRect;
    const desiredTop = safeTop + Math.max(0, (available - anchor.height) / 2);
    const scroller = document.scrollingElement || document.documentElement;
    const maximum = Math.max(0, scroller.scrollHeight - document.documentElement.clientHeight);
    const destination = Math.min(maximum, Math.max(0, window.scrollY + anchor.top - desiredTop));
    return {
      destination,
      inputVisible: inputRect.top >= safeTop - 3 && inputRect.bottom <= safeBottom + 3
    };
  }

  function goToNewsletter(keyboard = false) {
    if (usesDesktopPanel()) return;
    const target = getTarget();
    if (!target) return;
    allowInitialVisit = false;
    cancel();
    const now = performance.now();
    const initial = geometry(target);
    const state = {
      target, keyboard, started: now, lastScrollAt: now, lastChangeAt: now,
      lastCorrectionAt: now, lastY: window.scrollY,
      lastDestination: initial.destination, corrections: 0,
      hinted: false, alignedSince: 0
    };
    run = state;
    window.scrollTo({
      top: initial.destination,
      left: window.scrollX,
      behavior: reducedMotion.matches ? 'instant' : 'smooth'
    });

    function track(time) {
      if (run !== state) return;
      if (usesDesktopPanel() || document.hidden) { cancel(true); return; }
      if (!isVisible(state.target)) {
        // Shopify can replace a section after the first scroll has started.
        state.target = getTarget();
        if (!state.target) { cancel(true); return; }
      }
      const current = geometry(state.target);
      const y = window.scrollY;
      if (Math.abs(y - state.lastY) > 0.5) state.lastScrollAt = time;
      if (Math.abs(current.destination - state.lastDestination) > 1) state.lastChangeAt = time;
      state.lastY = y;
      state.lastDestination = current.destination;
      const error = Math.abs(current.destination - y);
      const settled = time - state.lastScrollAt > 180;
      const elapsed = time - state.started;
      const aligned = error <= 3 && current.inputVisible;

      if (aligned && settled) {
        if (!state.alignedSince) state.alignedSince = time;
        if (!state.hinted && time - state.alignedSince > 650) {
          state.hinted = true;
          showHint(state.target, state.keyboard);
        }
      } else {
        state.alignedSince = 0;
      }

      // A fixed eight-second ceiling: never keep pulling a visitor back forever.
      if (elapsed >= maxTrackingMs) {
        if (error > 3) {
          window.scrollTo({ top: current.destination, left: window.scrollX, behavior: 'instant' });
        }
        if (!state.hinted && geometry(state.target).inputVisible) showHint(state.target, state.keyboard);
        run = null;
        frame = 0;
        return;
      }

      // Do not restart a native smooth scroll while it is still moving.
      // Once it stops, remeasure and correct late image / section height changes.
      if (settled && elapsed > 300 && error > 3 &&
          time - state.lastCorrectionAt > 220 && state.corrections < 12) {
        state.corrections += 1;
        state.lastCorrectionAt = time;
        state.lastChangeAt = time;
        state.lastScrollAt = time;
        const behavior = !reducedMotion.matches && state.corrections === 1 &&
          error > window.innerHeight * 0.6 ? 'smooth' : 'instant';
        window.scrollTo({ top: current.destination, left: window.scrollX, behavior });
      }

      // Keep a short post-arrival watch for delayed content; no perpetual observer.
      if (elapsed > 3500 && aligned && settled &&
          time - state.lastChangeAt > 1400 && time - state.alignedSince > 1000) {
        run = null;
        frame = 0;
        return;
      }
      frame = window.requestAnimationFrame(track);
    }
    frame = window.requestAnimationFrame(track);
  }

  document.addEventListener('click', (event) => {
    if (usesDesktopPanel() || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') ||
        (link.target && link.target.toLowerCase() !== '_self')) return;
    let destination;
    try { destination = new URL(link.href, window.location.href); }
    catch (_) { return; }
    const samePath = destination.pathname.replace(/\/+$/, '') ===
      window.location.pathname.replace(/\/+$/, '');
    if (destination.origin !== window.location.origin || !samePath ||
        destination.hash !== hash ||
        (destination.search && destination.search !== window.location.search) || !getTarget()) return;
    event.preventDefault();
    if (window.location.hash !== hash) {
      try {
        const next = new URL(window.location.href);
        next.hash = hash;
        window.history.pushState(window.history.state, '', next.href);
      } catch (_) { /* Navigation inside an embedded preview can restrict history. */ }
    }
    goToNewsletter(event.detail === 0);
  }, true);

  window.addEventListener('hashchange', () => {
    if (window.location.hash === hash && !usesDesktopPanel()) goToNewsletter();
    else cancel();
  });

  // Explicit input cancels tracking immediately. No focusing the email field
  // on arrival: touch users should not get an unexpected software keyboard.
  function interrupt() {
    allowInitialVisit = false;
    cancel(true);
  }
  ['wheel', 'touchstart', 'pointerdown'].forEach((type) => {
    window.addEventListener(type, interrupt, { passive: true });
  });
  window.addEventListener('keydown', (event) => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Escape', 'Tab'].includes(event.key)) {
      interrupt();
    }
  });
  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element && event.target.matches('input, textarea, select, [contenteditable="true"]')) {
      interrupt();
    }
  });
  window.addEventListener('pagehide', () => cancel());
  document.addEventListener('visibilitychange', () => { if (document.hidden) cancel(true); });
  desktop.addEventListener('change', () => { if (usesDesktopPanel()) cancel(true); });
  reducedMotion.addEventListener('change', () => cancel(true));
  document.addEventListener('shopify:section:unload', (event) => {
    if (run && event.target instanceof Element && event.target.contains(run.target)) cancel(true);
  });

  function initialVisit() {
    if (!allowInitialVisit || window.location.hash !== hash || usesDesktopPanel() ||
        (window.Shopify && window.Shopify.designMode)) return;
    goToNewsletter();
  }
  if (document.readyState === 'complete') initialVisit();
  else window.addEventListener('load', initialVisit, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
